<template>
  <span>
    <div class="boss-layout-block">
      <div class="boss-text boss-layout boss-layout-gap-large pega-print-selection-top">
        <div>人事担当者</div>
        <div
          class="pega-print-staff-name-area pega-pre-wrap"
          data-test="responsible-staff-name"
        >{{ selectedResponsibleStaffName }}</div>
        <div>備考</div>
        <div
          data-test="remarks"
          class="pega-pre-wrap"
        >{{ remarks }}</div>
      </div>
    </div>
    <div class="boss-table-wrap pega-visible">
      <table class="boss-table-4 pega-th-color-important">
        <tr>
          <th>選考フェーズ</th>
          <th>評価</th>
          <th>評価コメント</th>
        </tr>
        <entry-print-selection-outline
          v-for="(selection, i) in selections"
          :key="i"
          :selection="selection"
        />
      </table>
    </div>
  </span>
</template>

<script>
import EntryPrintSelectionOutline from '@/components/molecules/EntryPrintSelectionOutline'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    EntryPrintSelectionOutline
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    selections: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedResponsibleStaffName: '',
      remarks: ''
    }
  },
  computed: {
    ...mapGetters('settings', [
      'responsibles'
    ])
  },
  created () {
    this.$http.secured.get(`/entry/view/entries/${this.entryId}/responsible_staff`).then(response => {
      this.selectedResponsibleStaffName = _.defaultTo(_.get(response.data, 'name'), '−')
    })
    this.$http.secured.get(`/entry/view/entries/${this.entryId}/remarks`).then(response => {
      this.remarks = response.data
    })
  }
}
</script>
